// A six-digit code box. Shared by the login step-up and the setup dialog so
// the two feel like the same control, because to the person typing they are.
import { useEffect, useRef } from 'react';

interface Props {
  value: string;
  onChange: (v: string) => void;
  /** Fired once the sixth digit lands — nobody should have to hunt for a
   *  button after typing a code they are racing a 30-second clock on. */
  onComplete: () => void;
  disabled?: boolean;
  autoFocus?: boolean;
}

export function MfaCodeInput({ value, onChange, onComplete, disabled, autoFocus }: Props) {
  const fired = useRef('');

  useEffect(() => {
    if (value.length === 6 && fired.current !== value) {
      fired.current = value;
      onComplete();
    }
    if (value.length < 6) fired.current = '';
  }, [value, onComplete]);

  return (
    <input
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]*"
      maxLength={6}
      autoFocus={autoFocus}
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
      placeholder="000000"
      className="w-full text-center text-2xl font-mono tracking-[0.5em] py-3 border border-gray-300 rounded-lg
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                 disabled:bg-gray-50 disabled:text-gray-400"
    />
  );
}
